import { render, staticRenderFns } from "./single-customer-orders.vue?vue&type=template&id=5bed202c&scoped=true"
import script from "./single-customer-orders.vue?vue&type=script&lang=js"
export * from "./single-customer-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed202c",
  null
  
)

export default component.exports